import { Text, Anchor } from "@mantine/core";
import { useIdleTimer } from 'react-idle-timer';
import { useState, useEffect } from 'react';
import { performLogout, prepareForLogout, getTimeZoneLabel, useTimezoneSettings } from './Helpers';
import { IconWorldPin } from '@tabler/icons-react';

interface LogoutProps {
    updateShowSessionError: (arg: boolean) => void,
    isDarkTheme: boolean
}

export const Logout = (props: LogoutProps) => {

    const [remaining, setRemaining] = useState<number>(0);
    const onIdle = () => {
        prepareForLogout();
        props.updateShowSessionError(true);
    }

    const { getRemainingTime } = useIdleTimer({
        onIdle,
        //timeout: 5000,
        timeout: 1200000,
        //timeout: 18000000 ,
        throttle: 500
    })

    useEffect(() => {
        const interval = setInterval(() => {
          setRemaining(Math.ceil(getRemainingTime() / 1000))
        }, 500)
    
        return () => {
          clearInterval(interval)
        }
      })

    return (
        <div>
            { useTimezoneSettings() ? 
                <><Text color={props.isDarkTheme ? 'white' : 'black'} align='left' id='timeZoneLabel' style={{ padding: '10px', display: 'inline-block' }} mt="md"> <IconWorldPin size={20} color={props.isDarkTheme ? 'white' : 'black'} /> {getTimeZoneLabel()}</Text>
                <Text align='right' style={{ padding: '10px', display: 'inline-block', float: 'right' }} mt="md">
                    <Anchor<"a">
                        href="#"
                        weight={700}
                        onClick={performLogout}
                    >
                        Log out
                    </Anchor>
                </Text></>
            :             
                <Text align='right' style={{padding:'10px'}} mt="md">
                <Anchor<"a">
                    href="#"
                    weight={700}
                    onClick={performLogout}
                >
                    Log out
                </Anchor>
                </Text> 
            }
        </div>
    );
}